import {inject, Pipe, PipeTransform} from '@angular/core';
import {DatePipe, formatDate} from '@angular/common';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  transform(value: string | number | Date | null | undefined, format = 'mediumDate'): string | null {
    if (!value) return null;

    const date = new Date(value);

    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(date);

    const getPart = (type: string) => parseInt(parts.find(p => p.type === type)?.value || '0', 10);

    const syntheticUtcDate = new Date(Date.UTC(
      getPart('year'),
      getPart('month') - 1,
      getPart('day'),
      getPart('hour'),
      getPart('minute'),
      getPart('second')
    ));

    const currentLang = this.translocoService.getActiveLang();

    return formatDate(syntheticUtcDate, format, currentLang, 'UTC');
  }

}
